import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import authService from '../services/AuthService';
import { validateUser } from '../redux/authSlice';

import { ROUTE_BACK_OFFICE_HOME, ROUTE_BACK_OFFICE_LOGIN } from '../../constants';

const ProtectedRoute = ({ permissions, children }) => {
  const dispatch = useDispatch();
  const { user, status } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!user && status === 'idle') {
      dispatch(validateUser());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, dispatch]);

  if (!user && (status === 'loading' || status === 'idle')) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to={ROUTE_BACK_OFFICE_LOGIN} replace />;
  }

  if (permissions && !permissions.some(permission => authService.hasPermission(permission))) {
    return <Navigate to={ROUTE_BACK_OFFICE_HOME} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
